import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { NetBadge } from "@/pages/admin/AdminCash";
import { LedgerTable, LedgerTotals } from "@/pages/admin/StaffLedger";
import { Wallet } from "lucide-react";

const istToday = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);

export default function MyCash() {
  const [range, setRange] = useState({ from_date: istToday().slice(0, 8) + "01", to_date: istToday() });
  const [d, setD] = useState(null);

  useEffect(() => { setD(null); api.get("/cash/mine", { params: range }).then((r) => setD(r.data)); }, [range]);

  const l = d?.ledger;
  return (
    <div className="space-y-4" data-testid="my-cash-section">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div className="text-sm text-slate-600 flex items-center gap-2"><Wallet className="w-4 h-4 text-[color:var(--bpcl-blue)]" /> Your cash ledger: shift shortage / excess, advances taken and money returned.</div>
        <div className="flex items-end gap-2">
          <div><Label className="text-xs">From</Label><Input data-testid="my-cash-from" type="date" className="h-10 rounded-xl mt-1" value={range.from_date} onChange={(e) => setRange((r) => ({ ...r, from_date: e.target.value }))} /></div>
          <div><Label className="text-xs">To</Label><Input data-testid="my-cash-to" type="date" className="h-10 rounded-xl mt-1" value={range.to_date} onChange={(e) => setRange((r) => ({ ...r, to_date: e.target.value }))} /></div>
          <Button variant="outline" className="h-10 rounded-xl" onClick={() => setRange({ from_date: "", to_date: istToday() })} data-testid="my-cash-all-time">All time</Button>
        </div>
      </div>

      {!l ? <div className="h-32 animate-pulse bg-slate-100 rounded-2xl" /> : (
        <>
          <Card className={`p-5 rounded-2xl border-2 ${l.closing_balance < 0 ? "border-red-200 bg-red-50/50" : l.closing_balance > 0 ? "border-emerald-200 bg-emerald-50/50" : "border-slate-200"}`}>
            <div className="text-xs uppercase tracking-wide text-slate-500">Current balance</div>
            <div className="text-2xl mt-1"><NetBadge v={l.closing_balance} testId="my-cash-net" /></div>
            <div className="mt-4"><LedgerTotals t={l.totals} /></div>
          </Card>
          <Card className="rounded-2xl border-slate-200 overflow-hidden"><div className="overflow-x-auto"><LedgerTable data={l} testId="my-cash-table" /></div></Card>
        </>
      )}
    </div>
  );
}
